export type AppConfig = {
  id: string;
  label: string;
  url: string;
  beta?: boolean;
};

const getEnv = (k: string, fallback: string) => {
  try {
    // Vite exposes import.meta.env, fallback to process.env for Node contexts
    // @ts-ignore
    const v = (typeof import.meta !== 'undefined' ? (import.meta.env?.[k] as string | undefined) : undefined) ||
      (typeof process !== 'undefined' ? (process.env?.[k] as string | undefined) : undefined);
    return v || fallback;
  } catch {
    return fallback;
  }
};

const getAppUrl = (id: string, envKey: string, fallback: string) => {
  const overrideKey = `VITE_APP_URL_OVERRIDE_${id.toUpperCase()}`;
  return getEnv(overrideKey, getEnv(envKey, fallback));
};

export const APPS: AppConfig[] = [
  {
    id: 'centraldb',
    label: 'Central DB',
    url: getAppUrl('centraldb', 'VITE_APP_URL_CENTRALDB', ''),
    beta: true,
  },
  {
    id: 'optima',
    label: 'Recruitment',
    url: getAppUrl('optima', 'VITE_APP_URL_OPTIMA', 'https://recruitment.optimauitzendburo.nl'),
    beta: true,
  },
  {
    id: 'saleslist',
    label: 'Saleslist',
    url: getAppUrl('saleslist', 'VITE_APP_URL_SALESLIST', 'https://sales.optimauitzendburo.nl'),
    beta: true,
  },
  {
    id: 'travel',
    label: 'Travel',
    url: getAppUrl('travel', 'VITE_APP_URL_TRAVEL', 'https://travel.optimauitzendburo.nl'),
    beta: true,
  },
  {
    id: 'fleet',
    label: 'Fleet',
    url: getAppUrl('fleet', 'VITE_APP_URL_FLEET', ''),
    beta: true,
  },
  {
    id: 'housing',
    label: 'Housing',
    url: getAppUrl('housing', 'VITE_APP_URL_HOUSING', 'https://housing.optimauitzendburo.nl'),
  },
  {
    id: 'stock',
    label: 'Stock',
    url: getAppUrl('stock', 'VITE_APP_URL_STOCK', 'https://stock.optimauitzendburo.nl'),
  },
  {
    id: 'administration',
    label: 'Administration',
    url: getAppUrl('administration', 'VITE_APP_URL_ADMINISTRATION', 'https://administration.optimauitzendburo.nl'),
  },
];
